"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriorityControl = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _SettingsBox = require("./SettingsBox");

var _routes = require("../../../utils/routes");

var _Box = require("./Box.styles");

const Wrapper = _styledComponents.default.div`
  label {
    display: block;
    margin-bottom: 8px;
  }

  label span {
    display: inline-block;
  }
`;

const PriorityControl = props => {
  if (props.insightType === _routes.InsightType.Monitoring) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Box.FieldLabel, null, "Response Priority"), /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(_blocks.RadioGroup, {
      disabled: !props.ruleEnabled,
      name: "priority-radio",
      options: _SettingsBox.OPTIONS,
      onChange: option => {
        props.onChange(option);
      },
      value: props.active,
      defaultValue: props.active
    })));
  } else {
    return /*#__PURE__*/React.createElement(_Box.CheckboxWrap, null, /*#__PURE__*/React.createElement(_blocks.Checkbox, {
      disabled: !props.ruleEnabled,
      label: "Prioritise",
      checked: props.active === 1,
      name: "SelectedRuleCheckbox",
      onChange: event => {
        props.onChange(event.target.checked ? 1 : 0);
      }
    }));
  }
};

exports.PriorityControl = PriorityControl;